const validationKeysBG = {
  translation: {
    "v-key-todo": "Todo",
  },
};

export default validationKeysBG;
